import React, {createContext, useContext, useState} from 'react';

export interface TotalSavings {
  bannerText: string;
  discountId: string;
}

interface TotalSavingsContextType {
  value?: TotalSavings;
  set: (value?: TotalSavings) => void;
}

const TotalSavingsContext = createContext<TotalSavingsContextType>({
  set: () => {},
  value: undefined,
});

export const useTotalSavings = () => useContext(TotalSavingsContext);

export const TotalSavingsProvider = ({children}: React.PropsWithChildren) => {
  const [savings, setSavings] = useState<TotalSavings>();

  return (
    <TotalSavingsContext.Provider value={{value: savings, set: setSavings}}>
      {children}
    </TotalSavingsContext.Provider>
  );
};
